import * as c from "react";
import { p as l } from "./index-efd35e77.js";
import { c as C, v as I, p as A } from "./package-metadata-a152adb8.js";
import { B as M } from "./Button-4c83e316.js";
import { a as N, b as P, d as R, c as D } from "./index.es-6889c727.js";
import { A as B } from "./Animation-154b683d.js";
import { g as L } from "./guid-fc0d51fd.js";
import { K as h } from "./keys-029ad48d.js";
var K = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), S = globalThis && globalThis.__assign || function() {
  return S = Object.assign || function(i) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (i[t] = n[t]);
    }
    return i;
  }, S.apply(this, arguments);
}, W = (
  /** @class */
  function(i) {
    K(n, i);
    function n() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.onClick = function() {
        r.props.onSelect && r.props.onSelect(r.props.index);
      }, r;
    }
    return n.prototype.render = function() {
      var r, e = this.props, t = e.id, o = e.active, a = e.disabled, s = e.title, p = s === void 0 ? "Untitled" : s, u = e.first, f = e.last, y = {
        id: t,
        "aria-selected": o,
        "aria-controls": t,
        "aria-disabled": a,
        "aria-hidden": a,
        role: "tab",
        onClick: a ? void 0 : this.onClick
      }, v = C("k-item", (r = {}, r["k-first"] = u, r["k-last"] = f, r["k-disabled"] = a, r["k-active"] = o, r));
      return c.createElement(
        "li",
        S({}, y, { className: v }),
        c.createElement("span", { className: "k-link" }, p)
      );
    }, n.propTypes = {
      active: l.bool,
      disabled: l.bool,
      index: l.number,
      onSelect: l.func,
      title: l.oneOfType([
        l.string,
        l.element
      ]),
      first: l.bool,
      last: l.bool
    }, n;
  }(c.Component)
), H = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), O = globalThis && globalThis.__assign || function() {
  return O = Object.assign || function(i) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (i[t] = n[t]);
    }
    return i;
  }, O.apply(this, arguments);
}, $ = function(i) {
  return Array.apply(null, Array(i));
}, F = function(i) {
  return i.preventDefault();
}, T = "smooth", m = "prev", w = "next", E = (
  /** @class */
  function(i) {
    H(n, i);
    function n(r) {
      var e = i.call(this, r) || this;
      return e.itemsNavRef = c.createRef(), e.isRtl = function() {
        return e.props.dir === "rtl";
      }, e.onWheel = function(t) {
        t.stopPropagation();
        var o = t.deltaY < 0 ? m : w;
        e.setNewScrollPosition(o, t);
      }, e.arrowClickPrev = function(t) {
        e.handleArrowClick(m, t);
      }, e.arrowClickNext = function(t) {
        e.handleArrowClick(w, t);
      }, e.handleArrowClick = function(t, o) {
        e.setNewScrollPosition(t, o);
      }, e.setNewScrollPosition = function(t, o) {
        var a = e.itemsNavRef.current;
        if (a) {
          var s = e.horizontalScroll(), p = s ? a.scrollWidth - a.offsetWidth : a.scrollHeight - a.offsetHeight, u = (o.type === "click" ? e.props.buttonScrollSpeed : e.props.mouseScrollSpeed) || 0, f = s ? a.scrollLeft : a.scrollTop, y = s ? a.scrollWidth - a.scrollLeft : a.scrollHeight - a.scrollTop, v = a.scrollWidth - a.scrollLeft * -1;
          e.isRtl() && e.horizontalScroll() ? (t === m && f < 0 && (f += u, v += u), t === w && f < p && (f -= u, v -= u), f = Math.min(0, Math.min(p, f))) : (t === m && f > 0 && (f -= u, y += u), t === w && f < p && (f += u, y -= u), f = Math.max(0, Math.min(p, f)));
          var b = f === 0, d = o.type === "click" ? T : void 0;
          if (s) {
            var k = e.isRtl() ? Math.round(v) <= a.clientWidth || Math.floor(v) <= a.clientWidth : Math.round(y) <= a.clientWidth || Math.floor(y) <= a.clientWidth;
            e.setState({
              disabledPrev: b,
              disabledNext: k
            }), a.scrollTo({ left: f, behavior: d });
          } else
            e.setState({
              disabledPrev: b,
              disabledNext: Math.round(y) <= a.clientHeight || Math.floor(y) <= a.clientHeight
            }), a.scrollTo({ top: f, behavior: d });
        }
      }, e.renderArrow = function(t, o) {
        var a = e.horizontalScroll(), s = {
          prev: {
            arrowTab: "k-tabstrip-prev",
            fontIcon: a ? e.isRtl() ? "caret-alt-right" : "caret-alt-left" : "caret-alt-up",
            svgIcon: a ? e.isRtl() ? N : P : R
          },
          next: {
            arrowTab: "k-tabstrip-next",
            fontIcon: a ? e.isRtl() ? "caret-alt-left" : "caret-alt-right" : "caret-alt-down",
            svgIcon: a ? e.isRtl() ? P : N : D
          }
        }, p = (t === m ? e.props.prevButton : e.props.nextButton) || M, u = t === m ? e.arrowClickPrev : e.arrowClickNext;
        return c.createElement(p, { disabled: o, className: "".concat(s[t].arrowTab), onClick: u, icon: s[t].fontIcon, svgIcon: s[t].svgIcon, onMouseDown: F, tabIndex: -1, fillMode: "flat" });
      }, e.state = {
        disabledPrev: e.props.selected === 0,
        disabledNext: e.props.selected === c.Children.count(e.props.children) - 1
      }, e;
    }
    return n.prototype.componentDidMount = function() {
      this.props.scrollable && this.scrollToSelected();
    }, n.prototype.componentDidUpdate = function(r) {
      var e = this.props, t = e.scrollable, o = e.selected;
      t && r.selected !== o && (this.scrollToSelected(), this.setState({
        disabledPrev: o === 0,
        disabledNext: o === c.Children.count(this.props.children) - 1
      }));
    }, n.prototype.render = function() {
      var r = this.props, e = r.selected, t = r.tabPosition, o = r.children, a = r.onSelect, s = r.onKeyDown, p = c.Children.count(o), u = c.Children.toArray(o), f;
      o && (f = $(p).map(function(b, d, k) {
        var j = {
          active: e === d,
          disabled: u[d].props.disabled,
          index: d,
          title: u[d].props.title,
          first: d === 0,
          last: d === k.length - 1,
          onSelect: a
        };
        return c.createElement(W, O({ key: d }, j));
      }));
      var y = C("k-tabstrip-items-wrapper", {
        "k-hstack": t === "top" || t === "bottom",
        "k-vstack": t === "left" || t === "right"
      }), v = C("k-tabstrip-items", "k-reset");
      return c.createElement("div", { className: y }, this.props.scrollable ? c.createElement(
        c.Fragment,
        null,
        this.renderArrow(m, this.state.disabledPrev),
        c.createElement("ul", { ref: this.itemsNavRef, className: v, role: "tablist", tabIndex: this.props.tabIndex, onKeyDown: s, onWheel: this.onWheel }, f),
        this.renderArrow(w, this.state.disabledNext)
      ) : c.createElement("ul", { className: v, role: "tablist", tabIndex: this.props.tabIndex, onKeyDown: s }, f));
    }, n.prototype.scrollToSelected = function() {
      var r, e, t, o, a = this.itemsNavRef.current, s = a && a.children[this.props.selected || 0];
      if (s instanceof HTMLElement && a instanceof HTMLElement) {
        var p = this.horizontalScroll(), u = p ? a.offsetWidth : a.offsetHeight, f = p ? s.offsetWidth : s.offsetHeight, y = p ? "left" : "top", v = p ? a.scrollLeft : a.scrollTop, b = 0;
        if (this.isRtl()) {
          var d = s.offsetLeft;
          v = v * -1, d < 0 ? (b = d - f + a.offsetLeft, a.scrollTo((r = {}, r[y] = b, r.behavior = T, r))) : d + f > u - v && (b = v + d - f, a.scrollTo((e = {}, e[y] = b, e.behavior = T, e)));
        } else {
          var d = p ? s.offsetLeft - a.offsetLeft : s.offsetTop - a.offsetTop;
          v + u < d + f ? (b = d + f - u, a.scrollTo((t = {}, t[y] = b, t.behavior = T, t))) : v > d && (b = d, a.scrollTo((o = {}, o[y] = b, o.behavior = T, o)));
        }
      }
    }, n.prototype.horizontalScroll = function() {
      return /top|bottom/.test(this.props.tabPosition || "top");
    }, n.propTypes = {
      children: l.oneOfType([
        l.element,
        l.arrayOf(l.element)
      ]),
      onSelect: l.func,
      onKeyDown: l.func,
      selected: l.number,
      tabIndex: l.number
    }, n;
  }(c.Component)
), U = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), x = globalThis && globalThis.__assign || function() {
  return x = Object.assign || function(i) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (i[t] = n[t]);
    }
    return i;
  }, x.apply(this, arguments);
}, V = globalThis && globalThis.__rest || function(i, n) {
  var r = {};
  for (var e in i)
    Object.prototype.hasOwnProperty.call(i, e) && n.indexOf(e) < 0 && (r[e] = i[e]);
  if (i != null && typeof Object.getOwnPropertySymbols == "function")
    for (var t = 0, e = Object.getOwnPropertySymbols(i); t < e.length; t++)
      n.indexOf(e[t]) < 0 && Object.prototype.propertyIsEnumerable.call(i, e[t]) && (r[e[t]] = i[e[t]]);
  return r;
}, X = (
  /** @class */
  function(i) {
    U(n, i);
    function n() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return n.prototype.render = function() {
      var r = this.props, e = r.children, t = V(r, ["children"]), o = {
        transitionName: "fade"
      };
      return c.createElement(B, x({}, o, t), e);
    }, n.propTypes = {
      children: l.oneOfType([
        l.arrayOf(l.node),
        l.node
      ]),
      childFactory: l.any,
      className: l.string,
      component: l.string,
      id: l.string,
      style: l.any
    }, n.defaultProps = {
      appear: !1,
      enter: !0,
      exit: !1,
      transitionEnterDuration: 500,
      transitionExitDuration: 500
    }, n;
  }(c.Component)
), Y = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), _ = globalThis && globalThis.__assign || function() {
  return _ = Object.assign || function(i) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (i[t] = n[t]);
    }
    return i;
  }, _.apply(this, arguments);
}, q = (
  /** @class */
  function(i) {
    Y(n, i);
    function n() {
      var r = i !== null && i.apply(this, arguments) || this;
      return r.contentId = L(), r.childFactory = function(e) {
        return c.cloneElement(e, _(_({}, e.props), { in: e.props.children.props.id === String(r.contentId + r.props.selected) }));
      }, r;
    }
    return n.prototype.render = function() {
      var r = this.props, e = r.children, t = r.selected, o = e && typeof t == "number" && c.Children.toArray(e)[t], a = C("k-content", "k-active", o && o.props.contentClassName);
      return c.createElement("div", { className: a, style: this.props.style }, this.renderContent(e));
    }, n.prototype.renderContent = function(r) {
      var e = this;
      return this.props.keepTabsMounted ? c.Children.map(this.props.children, function(t, o) {
        return e.renderChild(t, o);
      }) : this.renderChild(c.Children.toArray(r)[this.props.selected], this.props.selected);
    }, n.prototype.renderChild = function(r, e) {
      var t = e === this.props.selected, o = {
        role: "tabpanel",
        "aria-expanded": !0,
        "aria-labelledby": e.toString(),
        style: {
          display: t ? void 0 : "none"
        }
      }, a = {
        position: "initial",
        display: t ? void 0 : "none"
      };
      return r.props.disabled ? null : this.props.animation ? c.createElement(
        X,
        { appear: !0, exit: this.props.keepTabsMounted, style: a, childFactory: this.props.keepTabsMounted ? this.childFactory : void 0 },
        c.createElement("div", _({}, o, { id: String(this.contentId + e), key: e }), r.props.children)
      ) : c.createElement("div", _({}, o, { key: e }), r.props.children);
    }, n.propTypes = {
      animation: l.bool,
      children: l.oneOfType([
        l.element,
        l.arrayOf(l.element)
      ]),
      selected: l.number,
      style: l.object
    }, n;
  }(c.Component)
), G = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), g = globalThis && globalThis.__assign || function() {
  return g = Object.assign || function(i) {
    for (var n, r = 1, e = arguments.length; r < e; r++) {
      n = arguments[r];
      for (var t in n)
        Object.prototype.hasOwnProperty.call(n, t) && (i[t] = n[t]);
    }
    return i;
  }, g.apply(this, arguments);
}, ot = (
  /** @class */
  function(i) {
    G(n, i);
    function n(r) {
      var e, t = i.call(this, r) || this;
      return t._element = null, t.keyBinding = (e = {}, e[h.left] = function() {
        return t.prevNavigatableTab();
      }, e[h.right] = function() {
        return t.nextNavigatableTab();
      }, e[h.down] = function() {
        return t.nextNavigatableTab();
      }, e[h.up] = function() {
        return t.prevNavigatableTab();
      }, e[h.home] = function() {
        return 0;
      }, e[h.end] = function() {
        return c.Children.count(t.props.children) - 1;
      }, e), t.onSelect = function(o) {
        t.props.selected !== o && t.props.onSelect && t.props.onSelect({
          selected: o
        });
      }, t.onKeyDown = function(o) {
        var a;
        switch (o.keyCode) {
          case h.left:
            a = t.keyBinding[t.invertKeys(h.left, h.right)];
            break;
          case h.right:
            a = t.keyBinding[t.invertKeys(h.right, h.left)];
            break;
          case h.up:
            a = t.keyBinding[h.up];
            break;
          case h.down:
            a = t.keyBinding[h.down];
            break;
          case h.home:
            a = t.keyBinding[h.home];
            break;
          case h.end:
            a = t.keyBinding[h.end];
            break;
        }
        a && (o.preventDefault(), t.onSelect(a()));
      }, t.renderContent = function(o) {
        var a = o.selected, s = o.children, p = o.tabContentStyle, u = c.Children.count(s);
        return a < u && a > -1 ? c.createElement(q, g({ index: a }, o, { style: p })) : null;
      }, t.firstNavigatableTab = function() {
        var o = t.children(), a = c.Children.count(o);
        if (o) {
          for (var s = 0; s < a; s++)
            if (!o[s].props.disabled)
              return s;
        }
      }, t.lastNavigatableTab = function() {
        var o = t.children(), a = c.Children.count(o);
        if (o) {
          for (var s = a - 1; s > 0; s--)
            if (!o[s].props.disabled)
              return s;
        }
      }, t.prevNavigatableTab = function() {
        var o = t.children(), a = t.props.selected, s = a ? a - 1 : -1;
        if (s < 0)
          return t.lastNavigatableTab();
        if (o)
          for (var p = s; p > -1; p--) {
            if (!o[p].props.disabled)
              return p;
            if (p === 0)
              return t.lastNavigatableTab();
          }
      }, t.nextNavigatableTab = function() {
        var o = t.children(), a = t.props.selected, s = a ? a + 1 : 1, p = c.Children.count(o);
        if (s >= p)
          return t.firstNavigatableTab();
        if (o)
          for (var u = s; u < p; u++) {
            if (!o[u].props.disabled)
              return u;
            if (u + 1 === p)
              return t.firstNavigatableTab();
          }
      }, I(A), t;
    }
    return n.prototype.render = function() {
      var r = this, e = g(g({}, this.props), { children: this.children(), onKeyDown: this.onKeyDown, onSelect: this.onSelect }), t = e.tabPosition, o = e.tabIndex, a = o === void 0 ? 0 : o, s = t === "bottom", p = C("k-tabstrip", {
        "k-tabstrip-left": t === "left",
        "k-tabstrip-right": t === "right",
        "k-tabstrip-bottom": t === "bottom",
        "k-tabstrip-top": t === "top",
        "k-tabstrip-scrollable": this.props.scrollable
      }, this.props.className);
      return c.createElement(
        "div",
        { id: this.props.id, ref: function(u) {
          return r._element = u;
        }, dir: this.props.dir, className: p, style: this.props.style },
        !s && c.createElement(E, g({}, e, { tabIndex: a })),
        this.renderContent(e),
        s && c.createElement(E, g({}, e, { tabIndex: a }))
      );
    }, n.prototype.invertKeys = function(r, e) {
      var t = this._element && getComputedStyle(this._element).direction === "rtl" || !1;
      return t ? e : r;
    }, n.prototype.children = function() {
      return c.Children.toArray(this.props.children).filter(function(r) {
        return r;
      });
    }, n.propTypes = {
      animation: l.bool,
      children: l.node,
      onSelect: l.func,
      selected: l.number,
      style: l.object,
      tabContentStyle: l.object,
      tabPosition: l.string,
      tabIndex: l.number,
      className: l.string,
      dir: l.string
    }, n.defaultProps = {
      animation: !0,
      tabPosition: "top",
      keepTabsMounted: !1,
      buttonScrollSpeed: 100,
      mouseScrollSpeed: 10
    }, n;
  }(c.Component)
), J = globalThis && globalThis.__extends || function() {
  var i = function(n, r) {
    return i = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
      e.__proto__ = t;
    } || function(e, t) {
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }, i(n, r);
  };
  return function(n, r) {
    if (typeof r != "function" && r !== null)
      throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
    i(n, r);
    function e() {
      this.constructor = n;
    }
    n.prototype = r === null ? Object.create(r) : (e.prototype = r.prototype, new e());
  };
}(), at = (
  /** @class */
  function(i) {
    J(n, i);
    function n() {
      return i !== null && i.apply(this, arguments) || this;
    }
    return n.prototype.render = function() {
      return null;
    }, n.propTypes = {
      disabled: l.bool,
      contentClassName: l.string,
      children: l.oneOfType([
        l.element,
        l.node
      ]),
      title: l.oneOfType([
        l.string,
        l.element,
        l.node
      ])
    }, n;
  }(c.Component)
);
export {
  ot as T,
  at as a
};
